export default class Licence {
    constructor (dto) {
        this.fullUsers = ''
        this.concurrentUsers = ''
        this.readonlyUsers = ''
        this.registeredDevices = ''
        this.twoFactorAuthenticationUsers = ''
        this.licenceState = ''

        if (dto) {
            var registeredFullUsers = dto.licenseProperties.find(x => x.Title === 'RegisteredFullUsers')
            if (registeredFullUsers != null) {
                this.fullUsers = registeredFullUsers.Value
            }
            var concurrentUsers = dto.licenseProperties.find(x => x.Title === 'ConcurrentUsers')
            if (concurrentUsers != null) {
                this.concurrentUsers = concurrentUsers.Value
            }
            var registeredReadonlyUsers = dto.licenseProperties.find(x => x.Title === 'RegisteredReadonlyUsers')
            if (registeredReadonlyUsers != null) {
                this.readonlyUsers = registeredReadonlyUsers.Value
            }
            var registeredDevices = dto.licenseProperties.find(x => x.Title === 'RegisteredDevices')
            if (registeredDevices != null) {
                this.registeredDevices = registeredDevices.Value
            }
            var twoFactorAuthenticationUsers = dto.licenseProperties.find(x => x.Title === 'TwoFactorAuthenticationUsers')
            if (twoFactorAuthenticationUsers != null) {
                this.twoFactorAuthenticationUsers = twoFactorAuthenticationUsers.Value
            }
            var licenceState = dto.licenseProperties.find(x => x.Title === 'LicenceState')
            if (licenceState != null) {
                this.licenceState = licenceState.Value
            }
        }
    }
}
